// extracted by mini-css-extract-plugin
module.exports = {"form-row":"user-profile_form-row__3N1yj","button":"user-profile_button__38zTq","container":"user-profile_container__2p6KY","title":"user-profile_title__wqbFG"};